export default {
	SETTING_HOST_MESSAGING: 'messaging.deezerdev.com',
	API_HOST: 'local-api-music-analytics.deezerdev.com',
};
